// extracted by mini-css-extract-plugin
module.exports = {"container":"add-product_container__1oG5x","category-select":"add-product_category-select__2c2C5","choose-image-title":"add-product_choose-image-title__2rUXK"};